import * as React from 'react';
import * as _ from 'underscore';

import { ButtonType, ButtonWidget } from '@tableau/widgets';

import { Messages } from '../../../codegen/Localize';
import { SpaceContainerStyles } from '../../../style/SpaceContainerStyles';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../ts/services/BrowserTitleService';
import { Telemetry } from '../../../ts/services/TelemetryService';
import { ConnectedExplorer } from '../Explorer/ConnectedExplorer';
import { SpaceHeaderWithTotalItemsCount } from '../Header/SpaceHeaderWithTotalItemsCount';

export interface AllGroupsSpaceOwnProps extends ReactDirectiveProps {
  readonly siteName: string;
}

export interface AllGroupsSpaceAngularProps {
  readonly browserTitleService: BrowserTitleService;
  readonly telemetry: Telemetry;
}

export interface AllGroupsSpaceStateProps {
  readonly isBusyFetchingItems: boolean;
  readonly numberOfFetchedGroups: number;
  readonly canSessionUserManageUsers: boolean;
}

export interface AllGroupsSpaceDispatchProps {
  readonly requestSpaceContents: () => void;
  readonly addGroup: () => void;
}

export type AllGroupsSpaceNonAngularProps = AllGroupsSpaceOwnProps & AllGroupsSpaceStateProps & AllGroupsSpaceDispatchProps;
export type AllGroupsSpaceProps = AllGroupsSpaceAngularProps & AllGroupsSpaceNonAngularProps;

export class AllGroupsSpace extends React.PureComponent<AllGroupsSpaceProps> {
  public componentDidMount() {
    this.props.browserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.groups() });
    this.props.requestSpaceContents();
  }

  public componentDidUpdate(prevProps: AllGroupsSpaceProps) {
    if(!_.isUndefined(this.props.siteName) && prevProps.siteName !== this.props.siteName) {
      this.props.requestSpaceContents();
    }
  }

  public render(): JSX.Element {
    return(
      <div className={ SpaceContainerStyles.SpaceContainer }>
        <SpaceHeaderWithTotalItemsCount
          onClick={this.onSpaceHeaderClick}
          label={Messages.groups()}
          testId={'groups'}
          count={this.props.numberOfFetchedGroups}
          countUpToDate={!this.props.isBusyFetchingItems}
        />
        <div className={ SpaceContainerStyles.SubplaceArea }>
          <ConnectedExplorer
            angularContext={this.props.angularContext}
            supportedDisplayModes={['list']}
            telemetry={this.props.telemetry}
            toolbarProps={{
              supportFilterPanel: true,
              toolbarVisibility: 'enabled',
              toolbarContentSpecificControls: { beginning: this.addGroupButton() }
            }}
            emptyStateProps={{
              primaryMessage: Messages.groupsEmptyMessage()
            }}
          />
        </div>
      </div>
    );
  }

  private onSpaceHeaderClick = () => {
    this.props.requestSpaceContents();
  }

  private addGroupButton = () => {
    const handleClick = () => this.props.addGroup();
    return (
      <ButtonWidget
        children={Messages.addGroup()}
        buttonType={ButtonType.Outline}
        handleClick={handleClick}
        tb-test-id={'action-add-groups'}
        testId={'action-add-groups'}/>
    );
  }
}
